import Results2 from '../../assets/results2.png';
import Results3 from '../../assets/results3.png';
import Results4 from '../../assets/results4.png';
import Results6 from '../../assets/results6.png';
import Results7 from '../../assets/results7.png';
import Results8 from '../../assets/results8.png';
import Results9 from '../../assets/results9.png';
import Results10 from '../../assets/results10.png';
import Results11 from '../../assets/results11.jpg';

const results = [
  Results2,
  Results3,
  Results4,
  Results8,
  Results6,
  Results9,
  Results7,
  Results10,
  Results11,
];

export default results;
